export enum ServiceType {
  AddServiceType = 'Add Service Type',
  EditServiceType = 'Update Service Type',
  ListServiseTypes = 'List Services Types'
}